<template>
  <div class="AudioTitleComponent">
    <el-form ref="form" :model="question" label-width="90px">
      <el-form-item label="题干:">
        <el-input
          style="height: 100px"
          type="textarea"
          v-model="question.title"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
      <div class="changeTitleTypeBox">
        <div>
          <span>选择性别： </span>
          <el-radio-group v-model="voice" @change="handleChangeRole">
            <el-radio
              v-for="item in humanOption"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}
            </el-radio>
          </el-radio-group>
          <div>
            <div style="margin-top: 15px">
              <span>选择语速： </span>
              <el-radio-group v-model="speechRate" @change="handleChangeRate">
                <el-radio
                  v-for="item in rateArr"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </div>
            <div
              style="
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
              "
            >
              <div style="line-height: 54px">点击试听:</div>
              <div>
                <audio
                  :src="src"
                  loop="false"
                  controls
                  preload="auto"
                  controlsList="nodownload noplaybackrate"
                  ref="audioRef"
                ></audio>
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-button size="mini" type="primary" @click="handleClick"
            >转音频
          </el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { addLessonContentMixins } from "@/pages/MyOutLine/addLessonContentMixins";

export default {
  name: "AudioTitleComponent",
  mixins: [addLessonContentMixins],
  data() {
    return {
      voice: "zhiyuan",
      speechRate: 1.0,
      humanOption: [
        {
          label: "女",
          value: "zhiyuan",
        },
        {
          label: "男",
          value: "stanley",
        },
      ],
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
      src: "",
    };
  },
  computed: {
    ...mapState("courseCenter", ["audioDetail"]),
  },
  methods: {
    ...mapActions("courseCenter", ["getAudioUrl"]),
    async handleClick() {
      if (!this.question.title) {
        this.$message.warning("题干不能为空");
        return;
      }
      await this.getAudioUrl({
        text: this.question.title,
        speechRate: this.speechRate,
        voice: this.voice,
      });
      //音频url
      this.src = this.audioDetail.url;
      // 占位符
      this.question.titleAudio = this.audioDetail.url + ",";
      //音频类型
      this.question.titleAudioType = this.audioDetail.mimeType;
      // 转音频的文本
      this.material.audioText = this.question.title;
      // 媒体名称
      this.material.filename = this.audioDetail.filename;
      // 媒体ID
      this.material.materialId = this.audioDetail.id;
      // 媒体类型
      this.material.type = this.audioDetail.mimeType;
    },
    handleChangeRate(val) {
      this.speechRate = val;
    },
    handleChangeRole(val) {
      this.voice = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.AudioTitleComponent {
  .changeTitleTypeBox {
    margin-left: 90px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }

  ::v-deep .el-textarea__inner {
    min-height: 100px !important;
  }
}
</style>
